import { colunaDataSolicitacao } from './data-solicitacao'
import { colunaDisciplinaCurso } from './disciplina-curso'
import { colunaObservacao } from './observacao'

export const COLUNAS_EMENTA_DISCIPLINA = [
  colunaDisciplinaCurso(),
  colunaDataSolicitacao(),
  colunaObservacao()
]
